import type { Song } from './types';
import { styled } from 'styled-system/jsx';
import { Link } from '~/components/ui/link';
import { Table } from '~/components/ui/table';
import { getAlbumArtPublicPath } from '~/utils/assets';

type Props = {
  song: Song;
};

export function SongArtworkCell({ song }: Props) {
  return (
    <Table.Cell hideBelow="md" width="16" px="0">
      <Link href={`/${song.id}`}>
        <styled.img
          src={getAlbumArtPublicPath(song.id)}
          alt={`${song.title} album art`}
          objectFit="contain"
        />
      </Link>
    </Table.Cell>
  );
}
